import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useSearch } from '../../providers/search';

import { InputGroup } from './styles';
import { ContainerData, ButtonsGroup } from '../../global';
import Input from '../../components/Input';
import RedirectButton from '../../components/RedirectButton';
import { nameMask, cpfMask, phoneMask, validarCPF, validarEmail } from '../../utils/mask';

import { getStorage, setStorage } from '../../utils/storage';
import api from '../../service/api';

const PersonalData = () => {
  let context = getStorage();
  const { search, setSearch } = useSearch();
  const history = useHistory();

  const mapeamentoAnonimizado = parseInt(localStorage.getItem('mapeamento_anonimizado'));
  const emailOpcional = Boolean(localStorage.getItem('email_opcional'));

  const [allowedFields, setAllowedFields] = useState([]);
  useEffect(() => {
    const raw = localStorage.getItem('campos_pessoais') || '';
    setAllowedFields(
      raw
        .split(';')
        .map(s => s.trim())
        .filter(Boolean)
    );
  }, []);

  const shouldShow = (fieldKey) => allowedFields.includes(fieldKey);

  const [name, setName] = useState(context.userData.name);
  const [cpf, setCPF] = useState(context.userData.cpf);
  const [phone, setPhone] = useState(context.userData.phone);
  const [email, setEmail] = useState(context.userData.email);
  const [cargo, setCargo] = useState(context.userData.cargo || '');

  const cargoOptions = [
    "Selecione...",
    "Fotovoltaico",
    "Eficiência Energética",
    "Financeiro",
    "Supply Chain",
    "Recursos Humanos",
    "TI",
    "Jurídico",
    "Comercial/Marketing"
  ];

  const notify = (msg) => toast.warn(msg);

  // redirecionamentos iniciais
  useEffect(() => {
    if (localStorage.getItem('current_page') < 2) {
      history.push(`/${localStorage.getItem('current_page')}`);
    }
    if (mapeamentoAnonimizado === 1) {
      localStorage.setItem('current_page', 3);
      history.push(`/3`);
    }
    if (!localStorage.getItem('pesquisa')) {
      history.push('/erro');
    }
  });

  // handlers
  const handleName = e => setName(nameMask(e.target.value));
  const handleCPF = e => setCPF(cpfMask(e.target.value));
  const handlePhone = e => setPhone(phoneMask(e.target.value));
  const handleEmail = e => setEmail(e.target.value);
  const handleCargo = e => setCargo(e.target.value);

  async function findUserByCPF(userCPF) {
    const data = { chave_pesquisa: localStorage.getItem('pesquisa') };
    const resp = await api.post(`/api/questions/single/${userCPF}`, data);
    return resp.data === null;
  }

  async function handleForm() {
    const userData = { name, cpf, phone, email, cargo };

    // Validações
    if (shouldShow('name') && (name === '' || name.split(' ').length <= 1)) {
      notify('Verifique o nome completo');
      return;
    }

    if (shouldShow('cpf')) {
      if (cpf === '' || cpf.length < 14 || !validarCPF(cpf)) {
        notify('Verifique o CPF');
        return;
      }
      if (!(await findUserByCPF(cpf))) {
        notify('Usuário já participou da pesquisa!');
        return;
      }
    }

    if (shouldShow('phone') && (phone === '' || phone.length < 15)) {
      notify('Verifique o telefone');
      return;
    }

    if (shouldShow('email') && !emailOpcional) {
      if (email === '' || !validarEmail(email)) {
        notify('Verifique o e-mail');
        return;
      }
    }

    if (shouldShow('cargo') && (cargo === '' || cargo === 'Selecione...')) {
      notify('Selecione um cargo válido');
      return;
    }

    // salva e avança
    setSearch({ ...search, userData });
    context.userData = userData;
    setStorage(context);
    localStorage.setItem('current_page', 3);
    history.push(`/3`);
  }

  return (
    <ContainerData>
      <ToastContainer />
      <InputGroup>
        {shouldShow('name') && (
          <Input text="Nome completo (Titular)" onChange={handleName} value={name || ''} />
        )}
        {shouldShow('cpf') && (
          <Input text="CPF (Titular)" onChange={handleCPF} value={cpf || ''} />
        )}
        {shouldShow('email') && (
          <Input
            text="E-mail (Titular)"
            subtext={
              emailOpcional
                ? '* Não obrigatório'
                : '* Importante para receber uma cópia desta devolutiva'
            }
            onChange={handleEmail}
            value={email || ''}
          />
        )}
        {shouldShow('phone') && (
          <Input text="Celular (Titular)" onChange={handlePhone} value={phone || ''} />
        )}
        {shouldShow('cargo') && (
          <div>
            <label htmlFor="cargo">Área:</label>
            <select id="cargo" value={cargo} onChange={handleCargo}>
              {cargoOptions.map(opt => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>
        )}

        <ButtonsGroup>
          <RedirectButton redirect="back" pt="Voltar" en="back" onClick={() => {}} />
          <RedirectButton pt="Avançar" en="Next" onClick={handleForm} />
          <RedirectButton redirect="quit" pt="Abandonar" en="Quit Survey" onClick={() => {}} />
        </ButtonsGroup>
      </InputGroup>
    </ContainerData>
  );
};

export default PersonalData;